var radioToggle = {

	/**
	 * Init de radioToggle functies
	 *
	 * @param {object} target
	 *
	 * @returns {void}
	 */
	init: function(target) {

		radioToggle.initFunctions(target);
		radioToggle.initEvents(target);

	},

	/**
	 * Init de radioToggle functies
	 *
	 * @param {object} target
	 *
	 * @returns {void}
	 */
	initFunctions: function(target) {

		var toggleRadioElements = target.querySelectorAll('[data-radio-target-toggle-select]');
		toggleRadioElements.forEach(function(element) {
			radioToggle.toggleTargetRadio(element);
		});

	},

	/**
	 * Init de radioToggle events
	 *
	 * @returns {void}
	 */
	initEvents: function() {

		document.addEventListener('change', function(event) {
			for (var target = event.target; target && target != this; target = target.parentNode) {
				if (target.matches('[data-radio-target-toggle-select]')) {
					radioToggle.toggleTargetRadio(event.target);
					break;
				}
			}
		}, false);
	},

	/**
	 * Toon of verberg elementen opgegeven in data attribute
	 *
	 * @param {object} element
	 * @returns {void}
	 */
	toggleTargetRadio: function(element) {
		if (element.checked) {
			let target = element.getAttribute('data-radio-target-toggle-select');
			let targetElement = document.querySelector(target);
			targetElement.value = element.value;
		}
	},

};


export default radioToggle;
